import { Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

const CampaignOverview: React.FC = () => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <>
      <div className={classes.titleContainer}>
        <Typography className={classes.title}>{t('campaignOverviewPerformance')}</Typography>
      </div>
      <div className={classes.scrollContent}>
        <section className={classes.section}>
          <Typography className={classes.sectionTitle}>{t('exportCampaignResults')}</Typography>
          <Typography className={classes.sectionText}>{t('exportCampaignResultsDescription')}</Typography>
        </section>
        <section className={classes.section}>
          <Typography className={classes.sectionTitle}>{t('viewCampaignPerformance')}</Typography>
          <Typography className={classes.sectionText}>{t('viewCampaignPerformanceDescription')}</Typography>
        </section>
      </div>
    </>
  );
};

const useStyles = makeStyles()((theme) => ({
  titleContainer: {
    padding: '24px 64px',
  },
  title: {
    fontSize: theme.typography.pxToRem(25),
    fontWeight: 'bold',
    color: theme.palette.primary.main,
  },
  scrollContent: {
    padding: '0 64px 32px 64px',
    overflow: 'auto',
  },
  section: {
    marginTop: '32px',
    '&:first-of-type': {
      marginTop: '0px',
    },
  },
  sectionTitle: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 'bold',
    color: theme.palette.text.primary,
    marginBottom: '8px',
  },
  sectionText: {
    fontSize: theme.typography.pxToRem(16),
    color: theme.palette.text.secondary,
  },
  sectionList: {
    marginTop: '8px',
    marginBottom: '8px',
    paddingLeft: '32px',
    '& li': {
      marginBottom: '4px',
    },
  },
}));

export default CampaignOverview;
